





















































































import { Component, Vue, Watch } from "vue-property-decorator";
import Api from "@/api";

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import luxonPlugin from "@fullcalendar/luxon";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import resourceTimegridPlugin from "@fullcalendar/resource-timegrid";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";
import { IFacility, IVenue } from "@/interface";
import { AxiosResponse } from "axios";

let eventGuid = 0;
let todayStr = new Date().toISOString().replace(/T.*$/, ""); // YYYY-MM-DD of today
const schedulerLicenseKey = process.env.FULL_CALENDAR_LICENSE_KEY
  ? process.env.FULL_CALENDAR_LICENSE_KEY
  : "CC-Attribution-NonCommercial-NoDerivatives";

const INITIAL_EVENTS = [
  {
    id: createEventId(),
    title: "All-day event",
    start: todayStr
  },
  {
    id: createEventId(),
    title: "Timed event",
    start: todayStr + "T12:00:00"
  }
];

function createEventId() {
  return String(eventGuid++);
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    DatePicker
  }
})
export default class Scheduler extends Vue {
  private componentKey = 0;
  private facilities: Array<IFacility> = [];
  private selectedDate = new Date();
  private dateFormat = "DD.MM.YYYY";
  private CalendarApi: any = null;
  private calendarOptions: any = {
    schedulerLicenseKey,
    plugins: [
      dayGridPlugin,
      timeGridPlugin,
      interactionPlugin, // needed for dateClick
      luxonPlugin,
      resourceTimelinePlugin,
      resourceTimegridPlugin
    ],
    customButtons: {
      selectVenueButton: {
        text: "Select venues",
        click: function() {
          //
        }
      }
    },
    headerToolbar: {
      left: "today prev,next selectVenueButton",
      center: "title",
      right:
        "resourceTimelineDay5,resourceTimelineDay15,resourceTimelineDay,resourceTimelineDay60 resourceTimelineWeek resourceTimeGridDay"
    },
    views: {
      resourceTimelineDay: {
        type: "resourceTimeline",
        titleFormat: "{EEEE, {dd}. LLLL} yyyy",
        buttonText: "30m",
        slotDuration: "00:30",
        slotLabelFormat: ["HH:mm"]
      },
      resourceTimelineDay5: {
        type: "resourceTimeline",
        titleFormat: "{EEEE, {dd}. LLLL} yyyy",
        buttonText: "5m",
        slotDuration: "00:05",
        slotLabelFormat: ["HH:mm"]
      },
      resourceTimelineDay15: {
        type: "resourceTimeline",
        titleFormat: "{EEEE, {dd}. LLLL} yyyy",
        buttonText: "15m",
        slotDuration: "00:15",
        slotLabelFormat: ["HH:mm"]
      },
      resourceTimelineDay60: {
        type: "resourceTimeline",
        titleFormat: "{EEEE, {dd}. LLLL} yyyy",
        buttonText: "1h",
        slotDuration: "01:00",
        slotLabelFormat: ["HH:mm"]
      },
      resourceTimelineWeek: {
        type: "resourceTimeline",
        titleFormat: "{{d}. LLLL}. yyyy",
        slotDuration: "01:00",
        slotLabelFormat: "HH"
      },
      resourceTimeGridDay: {
        allDaySlot: true,
        buttonText: "Horizontal",
        titleFormat: "{EEEE, {dd}. LLLL} yyyy",
        slotLabelFormat: "HH"
      }
    },
    datesAboveResources: true,
    resourceGroupField: "",
    resources: [],
    height: "auto",
    allDaySlot: false,
    firstDay: 1,
    dayHeaders: true,
    dayHeaderFormat: "EEE d.M",
    datesSet: this.handleChangeDate,
    slotMinTime: "07:00:00",
    slotMaxTime: "23:00:00",
    slotLabelFormat: "HH:mm",
    eventTimeFormat: "HH:mm",
    slotDuration: "00:30:00",
    initialView: "resourceTimelineDay",
    initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
    editable: true,
    droppable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    weekends: true,
    select: this.handleDateSelect,
    eventClick: this.handleEventClick,
    eventsSet: this.handleEvents,
    eventDragStart: this.handleEventDragStart,
    eventDrop: this.handleEventDrop,
    eventReceive: this.handleEventDrop,
    resourceAreaHeaderContent: "Location"
    /* you can update a remote database when these fire:
      eventAdd:
      eventChange:
      eventRemove:
      */
  };
  private currentEvents: Array<any> = [];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.getFacilities(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.getFacilities(() => {
      //
    });
    next();
  }

  private mounted(): void {
    document
      .getElementsByClassName("fc-toolbar-chunk")[0]
      .prepend(document.getElementById("selected-date") as any);

    this.CalendarApi = (this.$refs.calendar as any).$options.calendar;
  }

  private getFacilities(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.facilities = response.data.data;
        response.data.data.map((facility: IFacility) => {
          facility.venues &&
            facility.venues.map((venue: IVenue) => {
              this.calendarOptions.resources.push({
                id: venue.id,
                title: venue.name,
                facility: facility.name
              });
            });
        });
        this.calendarOptions.resourceGroupField = "facility";
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private handleDateSelect(selectInfo: any): void {
    let title = prompt("Please enter a new title for your event");
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear date selection

    if (title) {
      calendarApi.addEvent({
        id: createEventId(),
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay
      });
    }
  }

  private handleEventClick(clickInfo: any): void {
    if (
      confirm(
        `Are you sure you want to delete the event "${clickInfo.event.title}"`
      )
    ) {
      clickInfo.event.remove();
    }
  }

  private handleEvents(events: Array<any>): void {
    this.currentEvents = events;
  }

  private handleEventDragStart(): void {
    this.CalendarApi.setOption("snapDuration", "00:05:00");
  }

  private handleEventDrop(): void {
    this.CalendarApi.setOption("snapDuration", "00:30:00");
  }

  private handleChangeDate(dateInfo: any): void {
    this.selectedDate = dateInfo.start;
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  @Watch("selectedDate")
  selectedDateChanged(newDate: Date): void {
    newDate && this.CalendarApi.gotoDate(newDate);
  }
}
